import React, { useEffect, useState } from 'react';
import api from '../../api/client';
import { useParams, Link as RouterLink } from 'react-router-dom';
import {
  Card, CardHeader, CardContent, Divider,
  Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Typography, Button, makeStyles,
} from '@material-ui/core';
import Layout from '../../components/layout/Layout';
import { gregorianToJalali, toFarsiDigits } from '../../assets/utils';

const useStyles = makeStyles(() => ({
  root: { background: '#f1f1f1', flexGrow: 1 },
  container: { maxHeight: '55vh' },
}));

export default function RequestsList() {
  const classes = useStyles();
  const { contractId } = useParams();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState('');

  useEffect(() => {
    let cancel = false;
    const run = async () => {
      try {
        setLoading(true);
        setErr('');
        const res = await api.get(`/contracts/${contractId}/requests/`, { params: { page_size: 200 } });
        const data = Array.isArray(res.data) ? res.data : (res.data.results || []);
        if (!cancel) setRows(data);
      } catch (e) {
        if (!cancel) setErr('خطا در دریافت صورت‌وضعیت‌ها');
      } finally {
        if (!cancel) setLoading(false);
      }
    };
    run();
    return () => { cancel = true; };
  }, [contractId]);

  return (
    <Layout>
      <Card elevation={5} className={classes.root}>
        <CardHeader title={`صورت‌وضعیت‌های قرارداد ${toFarsiDigits(contractId)}`} />
        <Divider />
        <CardContent>
          {err && <Typography color="error">{err}</Typography>}
          {loading && <Typography>در حال بارگذاری…</Typography>}

          <TableContainer className={classes.container} component={Paper}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell align="center"><strong>ردیف</strong></TableCell>
                  <TableCell align="center"><strong>شناسه</strong></TableCell>
                  <TableCell align="center"><strong>موضوع/عنوان</strong></TableCell>
                  <TableCell align="center"><strong>تاریخ</strong></TableCell>
                  <TableCell align="center"><strong>وضعیت</strong></TableCell>
                  <TableCell align="center"><strong>اقدام</strong></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row, i) => (
                  <TableRow key={row.id || i}>
                    <TableCell align="center">{toFarsiDigits(i + 1)}</TableCell>
                    <TableCell align="center">{toFarsiDigits(row.id)}</TableCell>
                    <TableCell align="center">{row.title || row.subject || '—'}</TableCell>
                    <TableCell align="center">
                      {row.date ? toFarsiDigits(gregorianToJalali(row.date)) :
                       row.created_at ? toFarsiDigits(gregorianToJalali(row.created_at)) : '—'}
                    </TableCell>
                    <TableCell align="center">{row.status_fa || row.status || '—'}</TableCell>
                    <TableCell align="center">
                      <Button
                        variant="contained"
                        color="primary"
                        component={RouterLink}
                        to={`/supervisor/contracts/${contractId}/requests/${row.id}`}
                      >
                        مشاهده
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
                {(!loading && rows.length === 0) && (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      <Typography>صورت‌وضعیتی ثبت نشده است.</Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>
    </Layout>
  );
}
